import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { CART_QUERY_KEYS } from '~/utils/cartCache';

export const useUpsertProductVehicleCapacity = () => {
  const mutation = graphql(`
    mutation UpsertProductVehicleCapacity(
      $platformProductLengthId: ID!
      $transportVehicleId: ID!
      $capacity: QuantityInput!
    ) {
      upsertProductVehicleCapacity(
        platformProductLengthId: $platformProductLengthId
        transportVehicleId: $transportVehicleId
        capacity: $capacity
      ) {
        id
      }
    }
  `);

  // Editing a capacity changes the loads-per-vehicle, which can affect the shipping
  // estimate, so invalidate both the cart and shipping-cost queries (mirrors
  // useUpdateCartTransport).
  return useGraphqlMutation(mutation, [...CART_QUERY_KEYS, 'shippingCost']);
};
